"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var TableauNlpSemanticmodelFieldValueConceptParentEnum;
(function (TableauNlpSemanticmodelFieldValueConceptParentEnum) {
    TableauNlpSemanticmodelFieldValueConceptParentEnum["Unspecified"] = "VALUECONCEPT_UNSPECIFIED";
    TableauNlpSemanticmodelFieldValueConceptParentEnum["None"] = "VALUECONCEPT_NONE";
    TableauNlpSemanticmodelFieldValueConceptParentEnum["Percent"] = "VALUECONCEPT_PERCENT";
    TableauNlpSemanticmodelFieldValueConceptParentEnum["Quoted"] = "VALUECONCEPT_QUOTED";
    TableauNlpSemanticmodelFieldValueConceptParentEnum["Location"] = "VALUECONCEPT_LOCATION";
    TableauNlpSemanticmodelFieldValueConceptParentEnum["Currency"] = "VALUECONCEPT_CURRENCY";
    TableauNlpSemanticmodelFieldValueConceptParentEnum["Date"] = "VALUECONCEPT_DATE";
})(TableauNlpSemanticmodelFieldValueConceptParentEnum = exports.TableauNlpSemanticmodelFieldValueConceptParentEnum || (exports.TableauNlpSemanticmodelFieldValueConceptParentEnum = {})); /**
* @export
* @enum {string}
*/
var TableauNlpSemanticmodelFieldValueConceptChildEnum;
(function (TableauNlpSemanticmodelFieldValueConceptChildEnum) {
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Airport"] = "VALUECONCEPT_AIRPORT";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Areacode"] = "VALUECONCEPT_AREACODE";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Zipcode"] = "VALUECONCEPT_ZIPCODE";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Country"] = "VALUECONCEPT_COUNTRY";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["State"] = "VALUECONCEPT_STATE";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["County"] = "VALUECONCEPT_COUNTY";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["City"] = "VALUECONCEPT_CITY";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Latitude"] = "VALUECONCEPT_LATITUDE";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Longitude"] = "VALUECONCEPT_LONGITUDE";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Nutseurope"] = "VALUECONCEPT_NUTSEUROPE";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Uscongressionaldistrict"] = "VALUECONCEPT_USCONGRESSIONALDISTRICT";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Cbsa"] = "VALUECONCEPT_CBSA";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Cents"] = "VALUECONCEPT_CENTS";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Usd"] = "VALUECONCEPT_USD";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Eur"] = "VALUECONCEPT_EUR";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Jpy"] = "VALUECONCEPT_JPY";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Gbp"] = "VALUECONCEPT_GBP";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Chf"] = "VALUECONCEPT_CHF";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Aud"] = "VALUECONCEPT_AUD";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Nzd"] = "VALUECONCEPT_NZD";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Cad"] = "VALUECONCEPT_CAD";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Sek"] = "VALUECONCEPT_SEK";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Nok"] = "VALUECONCEPT_NOK";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Hkd"] = "VALUECONCEPT_HKD";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Year"] = "VALUECONCEPT_YEAR";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Quarter"] = "VALUECONCEPT_QUARTER";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Month"] = "VALUECONCEPT_MONTH";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Week"] = "VALUECONCEPT_WEEK";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Weekday"] = "VALUECONCEPT_WEEKDAY";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Day"] = "VALUECONCEPT_DAY";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Hour"] = "VALUECONCEPT_HOUR";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Minute"] = "VALUECONCEPT_MINUTE";
    TableauNlpSemanticmodelFieldValueConceptChildEnum["Second"] = "VALUECONCEPT_SECOND";
})(TableauNlpSemanticmodelFieldValueConceptChildEnum = exports.TableauNlpSemanticmodelFieldValueConceptChildEnum || (exports.TableauNlpSemanticmodelFieldValueConceptChildEnum = {}));
function TableauNlpSemanticmodelFieldValueConceptFromJSON(json) {
    return TableauNlpSemanticmodelFieldValueConceptFromJSONTyped(json, false);
}
exports.TableauNlpSemanticmodelFieldValueConceptFromJSON = TableauNlpSemanticmodelFieldValueConceptFromJSON;
function TableauNlpSemanticmodelFieldValueConceptFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'parent': !runtime_1.exists(json, 'parent') ? undefined : json['parent'],
        'child': !runtime_1.exists(json, 'child') ? undefined : json['child'],
    };
}
exports.TableauNlpSemanticmodelFieldValueConceptFromJSONTyped = TableauNlpSemanticmodelFieldValueConceptFromJSONTyped;
function TableauNlpSemanticmodelFieldValueConceptToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'parent': value.parent,
        'child': value.child,
    };
}
exports.TableauNlpSemanticmodelFieldValueConceptToJSON = TableauNlpSemanticmodelFieldValueConceptToJSON;
